<script type="text/javascript" >
import { accountModuleOutput, showCards, upgradeText } from "./types";

export default {
  name: "MemberGuideData",
  data() {
    return {
      show: false,
      userMsg: {},
      accountInfoModule: [],
      rightsModule: [],
      mattingModule: {},
      endDate: "",
      cards: {},
      upgradeVipInfo: {},
      upgradeShopVipInfo: {},
      upgradeEnterpriseVipInfo: {},
      upgradeUpEnterpriseVipInfo: {},
      vipLevelInfo: {},
      activityInfo: {},
      levelTypeTag: "",
      apiFinish: false,
    };
  },
  computed: {},
  async created() {
    this.getActivityAndRights();
  },
  watch: {
    funcRight(nv, ov) {
      if (nv.type === "" || !this.apiFinish) {
        return;
      }
      this.updateRenderInfo();
    },
    apiFinish(nv) {
      if (nv) {
        this.updateRenderInfo();
      }
    },
  },
  methods: {
    formatDate(timestamp) {
      //日期
      let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate();
      return Y + M + D;
    },
    formatTime(timestamp) {
      // 日期
      let a = Math.floor(timestamp / 60 / 60);
      let b = Math.floor((timestamp - a * 3600) / 60);
      let c = Math.ceil(timestamp - a * 3600 - b * 60);
      let h = a < 10 ? "0" + a : a;
      let m = b < 10 ? "0" + b : b;
      let s = c < 10 ? "0" + c : c;
      return h + "时" + m + "分" + s + "秒";
    },
    getResources(url) {
      return this.$http.get(url);
    },
    getLevelTagName(userMsg) {
      let levelTypeTag = "";
      if (userMsg.level === 0 && userMsg.levelType === 0) {
        levelTypeTag = "isPoor";
      } else if (userMsg.level > 0 && userMsg.levelType === 0) {
        levelTypeTag = "isSolo";
        if (userMsg.levelNewType === 6) {
          levelTypeTag = 'isShop';
        }
      } else if (userMsg.tmpLevel > 0 && userMsg.tmpLevelType === 0) {
        levelTypeTag = "isTmpSolo";
      } else if (userMsg.levelType > 0) {
        if (userMsg.levelType < 2) {
          levelTypeTag = "isEnterprise"; // 企业荣耀版以下
        } else if (userMsg.levelType === 2) {
          levelTypeTag = "isGloryEnterprise";
        } else {
          levelTypeTag = "isUpGloryEnterprise"; // 企业荣耀版以上
        }
      } else if (userMsg.tmpLevelType > 0) {
        levelTypeTag = "isTmpEnterprise"; // 除企业至尊之外其他的体验版
        if (userMsg.tmpLevelType === 3) {
          levelTypeTag = "isTmpSupremeEnterprise"; // 特殊的至尊版体验版
        }
      }
      return levelTypeTag;
    },
    getMonthYearRes(result) {
      const data = result.data && result.data.data;
      const allInfo = data[Object.keys(data)[0]];
      const monthRes = allInfo.find((item) => item.month === 1);
      // 年度
      const yearRes = allInfo.find((item) => item.month === 12);
      return { monthRes, yearRes };
    },
    async getActivityAndRights() {
      const sessionRes = await this.getResources(`/api/session`);
      this.userMsg = (sessionRes.data && sessionRes.data.data) || {};
      const isTmp = this.userMsg.tmpLevel > 0 ? `&isTmp=1` : "";
      const level = isTmp ? this.userMsg.tmpLevel : this.userMsg.level;
      const urls = {
        rights: `/api/user/vip/rights?levelType=${this.userMsg.levelType}`,
        vipLevelInfo: `/api/user/vipLevelInfo?level=${level}${isTmp}`,
        activityInfo: `/api/promotion/activities/getByType?type=2`,
        vipInfo: `/api/user/vipLevelInfo?levelType=0&platform=0`,
        enterpriseVip: `/api/user/vipLevelInfo?levelType=2&platform=0`,
        upgradeUpEnterpriseVipInfo: `/api/user/vipLevelInfo?levelType=3&platform=0`,
      };
      let tasks = [];
      for (let key in urls) {
        tasks.push(this.getResources(urls[key]));
      }
      const res = await Promise.all(tasks);
      tasks = [];
      this.levelTypeTag = this.getLevelTagName(this.userMsg);
      // let levelName = this.userMsg.levelName;
      let rightsModule = (res[0].data && res[0].data.data) || [];
      this.vipLevelInfo = (res[1].data && res[1].data.data) || [];
      this.activityInfo = (res[2].data && res[2].data.data) || [];
      rightsModule.sort((a, b) => {
        return parseInt(a.price) - parseInt(b.price);
      });
      this.endDate = this.formatDate(this.userMsg.endDay); // 会员截止时间
      this.rightsModule.push(rightsModule[0]);

      const vipRes = res.slice(3, 6);
      const vipInfos = [];
      vipRes.forEach((item) => {
        if (item.data) {
          const { monthRes, yearRes } = this.getMonthYearRes(item);
          vipInfos.push({ monthRes, yearRes });
        }
      });
      const personVipLevels = vipRes[0].data.data[0];
      const shopLevel = personVipLevels[personVipLevels.length - 1];
      this.upgradeShopVipInfo.year = shopLevel;
      let selfDiscount = Math.round(
        (parseFloat(vipInfos[0].monthRes.firstAutomaticContractPrice) * 10) /
          parseFloat(vipInfos[0].monthRes.originalPrice)
      );
      vipInfos[0].monthRes.selfDiscount = selfDiscount;
      // 买送优惠信息

      if (vipInfos[0].yearRes.attached !== 0) {
        let endTime = new Date(
          this.activityInfo.endTime.split(".")[0]
        ).getTime();
        let nowTime = new Date().getTime();
        if (endTime - nowTime > 0) {
          const deadDay =
            endTime - nowTime > 1000 * 60 * 60 * 24
              ? Math.floor((endTime - nowTime) / 1000 / 60 / 60 / 24)
              : 0;
          let deadTime = "";
          if (deadDay < 1) {
            deadTime = (endTime - nowTime) / 1000;
            this.countdown(deadTime - 1);
          }
          vipInfos[0].yearRes.showActivityTime = true;
          vipInfos[0].yearRes.deadDay = deadDay;
          vipInfos[0].yearRes.deadTime = this.formatTime(deadTime);
        } else {
          vipInfos[0].yearRes.showActivityTime = false;
        }
      }
      this.upgradeVipInfo.month = vipInfos[0].monthRes;
      this.upgradeVipInfo.year = vipInfos[0].yearRes;
      // 折扣优惠信息
      // console.log('vipInfos==============>', this.upgradeVipInfo);

      // 企业荣耀版vip
      this.upgradeEnterpriseVipInfo.month = vipInfos[1].monthRes;
      this.upgradeEnterpriseVipInfo.year = vipInfos[1].yearRes;

      // 企业至尊版vip
      this.upgradeUpEnterpriseVipInfo.month = vipInfos[2].monthRes;
      this.upgradeUpEnterpriseVipInfo.year = vipInfos[2].yearRes;

      this.updateRenderInfo();
    },
    updateRenderInfo() {
      let cardLists = [];
      let texts = "";
      this.accountInfoModule = accountModuleOutput({
        userMsg: this.userMsg,
        vipLevelInfo: this.vipLevelInfo,
        funcType: this.funcRight.type,
        levelName: this.userMsg.levelName || this.userMsg.tmpLevelName,
        levelTypeTag: this.levelTypeTag,
      });
      this.cards = showCards({
        userMsg: this.userMsg,
        levelTypeTag: this.levelTypeTag,
        funcType: this.funcRight.type,
      });
      const { vipText, shopText, enterpriseText, upEnterpriseText } = upgradeText({
        funcType: this.funcRight.type,
        vipInfo: this.upgradeVipInfo.month,
        shopInfo: this.upgradeShopVipInfo.year,
        enterpriseInfo: this.upgradeEnterpriseVipInfo.year,
        upEnterpriseInfo: this.upgradeUpEnterpriseVipInfo.year,
      });
      this.cards = {
        ...this.cards,
        vipText,
        shopText,
        enterpriseText,
        upEnterpriseText
      };

      if (this.cards.right) {
        cardLists.push("权益包");
      }
      if (this.cards.vip) {
        cardLists.push("个人会员");
      }
      if (this.cards.enterpriseVip || this.cards.upEnterpriseVip) {
        cardLists.push("企业会员");
      }
      if (this.cards.matting) {
        cardLists.push("抠图宝");
      }
      this.accountInfoModule.forEach((item) => {
        texts += item.name;
      });
      this.apiFinish = true;
      // console.log('this.accountInfoModule', texts);
      if (this.funcRight.type !== "") {
        sensors.track("doratoonGuideePopup", {
          popup_content: texts, // 弹窗引导内容
          restricted_function: this.funcRight.name, // 受限功能
          popup_category1: cardLists, // 弹窗分类
        });
      }
    },
    countdown(t) {
      let timer = setTimeout(() => {
        if (t <= 0) {
          clearTimeout(timer);
          this.upgradeVipInfo.year.showActivityTime = false;
          return;
        }
        this.upgradeVipInfo.year.deadTime = this.formatTime(t);
        this.$forceUpdate();
        t--;
        this.countdown(t);
      }, 1000);
    },
    close() {
      this.show = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/plugins/memberGuide/data.vue